import { atom } from "jotai";

export const selectedRowsAtom = atom<number[]>([]);
